// @ts-nocheck
import { GlobalSvgSprites } from 'www/svg-icons/lib/global-svg-sprites';
import { Medscape } from 'www/medscape';
import { ReCapToolbar } from './modules/recap/recap-toolbar';
import { VideoLoader } from 'www/modules/video/video-loader';
import { SponsoredVideo } from 'www/modules/video/sponsored-video';
import { Playlist } from './modules/recap/playlist';
import { getSecondsFromTimeString } from 'www/utils/get-seconds-from-time-string';
//import { StreamingVideoPlayer } from '@medscape/streaming-video-player';
import { ArticlePoll } from 'www/modules/article-poll';
Medscape.ArticlePage.type = "RECAP";
import { PlayListAPI } from './modules/recap/filmstrip/recap-filmstrip';
import { RecapTemp } from './modules/recap/recap-temp';
import { Indiscussion } from './modules/recap/indiscussion';
import { StickyVideo } from './modules/common/sticky-video/sticky-video';
import { CommonSVPLoadModule as SVPLoader } from '../../modules/svpload/common-svp-load-module';
import { CloseCaptionReconfig } from './modules/recap/close-caption';
import { DirectIFI } from './modules/recap/direct-ifi';
import { VideoChapters } from '../../modules/video-chapters/video-chapters';
import { cpArticleLoad } from 'www/modules/cp/cp-article-load';
import { WatchListFabButton } from '../promos-articles/modules/save-video/watchlist-fab-button';
import { VideoSaver } from './modules/save-video/save-video';
export default class RecapArticle {
    constructor(el) {
        window.performance.mark('eedRecap_start', {
            detail: "Page loaded Recap Article constructor called",
        });
        this.el = el;
        window._isClinicalLens = $('.clinical-lens').length>0;
        this._isDirectIfi = this.checkDirectIfi();
        // temp code adding layer ads to be ignored
        if( typeof ads2_ignore == "object" && this._isDirectIfi) {
            ads2_ignore [105] = "true";
            ads2_ignore [107] = "true";
            ads2_ignore [201] = "true";
            ads2_ignore [1005] = "true";
        }

        if(!window._isClinicalLens) {
            this.el.classList.add('recap-article');
            if($('.recap-guidance').length>0){
                this.el.classList.add('recapguidance');
            }
            if($('.recap-text').length>0){
                this.el.classList.add('recaptext');
            }
        } else {
            this.el.classList.add('no-bg-gradiant');
        }
        this.addEventListnerForIFI();
        this._player = null;
        this.playlistContainer = null;
        this._sponsoredContentContainer = null;
        this.PlayerReadyCallbacks = [];
        this.checkProductName();
        this.addSactId();
        this.playlistVideos = [];
        Medscape.RecapArticle = this;
        this.recapTemp = new RecapTemp();
        if(this._isDirectIfi) {
            this.directIfi = new DirectIFI();
        }
        window._isIndiscussion = $('.in-discussion').length>0;
        if (window._isIndiscussion) {
            window.s_sprod = "InDiscussion";
            window.s_sprodid = "104";
            this.indiscussionArticle();
        }
        if (window._isCareCues) {
            if(!isFPFEligible) this.addReadMoreCareCues();
            this.addEventListenerForPRMLinks();
        }
        if(window._ismdAngle || $('.md-angle').length > 0) {
            this.addEventListenerForPRMLinks();
        }
        this.ccReconfig = new CloseCaptionReconfig();
        this.indiscussion = new Indiscussion();
        this.nextVideoIndex = 0;
        this.nextVideoUrl = "";
        this.sticky = {};
		this.parentSel = (typeof mscpA2A == 'boolean' && mscpA2A) ? '.inf-art-wrap[data-contenturl="' + currSlctCont + '"] ' : '';
		
    }
    get player() {
        if (this._player == null) {
            let container = document.querySelector('.streaming-video-player');
            if (container != null) {
                this._player = container.amp;
            }
        }
        return this._player;
    }
    set player(player = null) {
        this._player = player;
    }
    get sponsoredContentContainer() {
        if (this._sponsoredContentContainer == null) {
            let sponsoredContentContainer = document.createElement('div');
            sponsoredContentContainer.classList.add('sponsored-content-container');

            this.playlistContainer.before(sponsoredContentContainer);
            this._sponsoredContentContainer = sponsoredContentContainer;
        }
        return this._sponsoredContentContainer;
    }
    init() {
        let playListApi = new PlayListAPI();
        // alert("call made");

        try {
            this.insert800Ad('800', 800).insert800Ad('1800', 1800);
        } catch (error) {
            console.log(error);
        }
        ArticlePoll.init(this.el);
        this.initSvgSprites();
        if (!window._isIndiscussion && !this._isDirectIfi) {
            // Add carousel for medaffairs
            if(window._ismdAffairs){
                this.patchCmeVideoPlayer();
                this.waitAndPatchCMEPlayer();
            }
            const loadAfterSavedItems = () => {
            this.loadVideo().then(event => {
                let { player } = event;
                window.player = player;
                this.player = player;
                if (window._isClinicalLens || (window._isRecap && $(".page-body.recap").length > 0) || window._ismdAngle || window._isCareCues) {
                    let chapters = this.getChaptersfromConfig();
                    if (typeof chapters === 'object') {
                        const videoChapters = new VideoChapters(this.parentSel + '.svp-module', chapters, this.player);
                        videoChapters.init();
                    }
                }
                const bucketId = $(this.parentSel + "#bucketCollectionId").length > 0 ? $(this.parentSel + "#bucketCollectionId").val().split(',')[0] : (typeof window.bucketCollectionId == "string" || typeof window.bucketCollectionId == "number") ? window.bucketCollectionId : "";
                if (!window._ismdAffairs) {
                    this.sticky = new StickyVideo(this.parentSel + "[id*=eed-video] .svp-module", $(this.parentSel + "h1.title").text());
                    this.sticky.init();
                }
                if (bucketId) {
                    playListApi.callApi(bucketId).then((data) => {
                        if (data["articles"]) {
                            this.playlistVideos = playListApi.createPlaylist(data["articles"]);
                            this.nextVideoIndex = playListApi.getNextVideoIndex();
                            this.nextVideoUrl = this.nextVideoIndex > 0 && (this.playlistVideos[this.nextVideoIndex] && this.playlistVideos[this.nextVideoIndex]["link"]) ? this.playlistVideos[this.nextVideoIndex]["link"] : "";
                            if($('.llr-driver').length > 0){ // preventing play next video for llr page
                                this.nextVideoUrl = null;
                            }
                            this.nextVideoTitle = this.nextVideoIndex > 0 && this.playlistVideos[this.nextVideoIndex] ? this.playlistVideos[this.nextVideoIndex]["playlist"]["title"] : "";
                            if (!window._ismdAffairs) {
                                if (typeof this.sponsoredVideoData == "object") {
                                    this.sticky.setIFIVideo(this.sponsoredVideoData.title, ".content-container.ifi .flex-content");
                                }
                                else if (this.nextVideoTitle) {
                                    this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                                }
                            }
                            this.loadPlaylist().then(el => {
                                if (window._ismdAngle || window._ismdAffairs || this.playlistVideos.length > 1) {
                                    this.recapTemp.createCarousel(this.nextVideoIndex - 1);
                                }
                            });
                        }
                        player.AmpEventsSources["ended"].subscribe(_event => {
                            if (typeof this.sponsoredVideoData !== "object") {
                                this.autoPlayNextVideo();
                            }
                        });
                    });
                }
                this.PlayerReadyCallbacks.forEach( cb => {
                    cb();
                })
                this.addVideoSaverToolBar();
            },
            error => {
                if (error) console.error("Load Video Error:", error);
                else console.log('Video placeholder element not found. Searched for [data-module="streaming-video-player"]'); // fail gracefully when cme video player is being used
            }); 
            } 
            this.addWatchListButton(loadAfterSavedItems);
        } else if(this._isDirectIfi && !_isIndiscussion) {
            this.addWatchListButton(()=>{
                this.directIfi.init();
            });
        } else {
            // console.log("__ recap indiscussion condition");
            this.indiscussion.init();
        }
        if (PageMetadata.pageSegVars.ctype == '20171') {
            cpArticleLoad('carecues');
        } else if ([20172, 650146, 590146, 49139, 330148].includes(PageMetadata.pageSegVars.ctype)) {
            cpArticleLoad('armslength');
        }
        else {
            cpArticleLoad('recap');
        }
        this.gTagConversion();

    }
    initSvgSprites() {
        document.body.appendChild(GlobalSvgSprites.el);
    }
    hideSponsoredContent() {
        let { sponsoredContentContainer } = this;
        sponsoredContentContainer.classList.remove('show')
    }
    loadSponsoredContent(config = null) {
        let { sponsoredContentContainer } = this;
        if (config != null && sponsoredContentContainer.innerHTML == "") {
            const { "html-content": htmlContent, theme, title } = config;
            //let themeClass = theme == "dark" ? "theme-dark" : "";
            let themeClass = "theme-dark";
            if (themeClass.trim() != "") {
                sponsoredContentContainer.classList.add(themeClass);
            }

            sponsoredContentContainer.innerHTML = `
                <div class="sponsored-html-content">
                    ${htmlContent}
                </div>
                <div class="sponsored-meta-data">
                    <div class="label">Information From Industry</div>
                    <div class="title">${title}</div>
                </div>
            `;
        }
        sponsoredContentContainer.classList.add("show");

    }
    loadPlaylist() {
        const { videoSettings, sponsoredVideoData, videoApiData, sponsoredVideo } = this;
        const { videoConfig: sponsoredVideoConfig } = sponsoredVideoData ? sponsoredVideo: "";
        const playlistTheme = sponsoredVideoData ? sponsoredVideoData.playlist.theme: "dark";
        let thumbnail = videoApiData.config.poster;
        if (typeof(thumbnail) == 'undefined' || thumbnail.trim() == '') {
            thumbnail = videoApiData.config.bumperImage;
        }
        let playListApi = new PlayListAPI();
        let videoData = {
            "isIfi": false,
            "isPlaylist": false,
            "playlist": {
                "thumbnail": thumbnail,
                "header": "",
                "title": playListApi.enhanceTitleForViewability(videoSettings.title)
            },
            "video": videoSettings
        }
        let ifiVideo;
        let ifiData = {};

        if(typeof sponsoredVideoConfig == "object") {
            ifiVideo = Object.assign({}, sponsoredVideoData.video, {
                title: sponsoredVideoConfig.title
            });
            ifiData = {
                "isIfi": true,
                "isPlaylist": false,
                "playlist": {
                    "title": playListApi.enhanceTitleForViewability(sponsoredVideoConfig.title)
                },
                "video": ifiVideo
            }
            ifiData.playlist = Object.assign({}, ifiData.playlist, sponsoredVideoData.playlist);
        }
        let playListVideo = this.playlistVideos.length > 0 ? this.playlistVideos : [];
        this.playlistVideos = this.playlistVideos.map(e => {
            if (e.playlist != "undefined") {
                if(e.video == "current video") {
                    e["video"] = videoSettings;
                    return e
                }
                return e
            }
        })
        let playlistItems = playListVideo;
        if( this.nextVideoIndex > 0 && typeof sponsoredVideoConfig == "object") {
            playlistItems.splice(this.nextVideoIndex, 0, ifiData);
        } else if (typeof ifiVideo == "object") {
            playlistItems = [videoData, ifiData];
        }

        // let playlistItems = typeof ifiVideo == "object" ? [videoData, ifiData, ...playListVideo]: [videoData, ...playListVideo];

        let playlist = new Playlist(playlistItems, this.SVP, "dark", this.sticky);
        return playlist.create().then(playlist => {
            this.playlist = playlist;
            let container = document.getElementById('eed-video');
            if(!container) container = document.getElementById('cme-video-player').parentNode;
            let playlistContainer = document.createElement('div');

            playlistContainer.classList.add('playlist-container');

            playlistContainer.appendChild(playlist.el);
            if($(".playlist-container").length > 0) {
                $(".playlist-container").remove();
                // this.recapTemp.createCarousel();
            }
            container.appendChild(playlistContainer);
            this.playlistContainer = playlistContainer;
            let headingEl = document.querySelector('.title-area .heading');
            headingEl.classList.add('theme-dark');
            headingEl.classList.add('has-playlist');
            setTimeout(() => {
                playlist.el.classList.add("ready");
            }, 10);
            return playlist;

        })
    }
    loadSponsoredVideo(config = null) {
        this.performanceMarker('recap');
        if(this._isDirectIfi) {
            this.directIfi.playIFIVideo(config);
            return;
        }
        if (isNaN(config.video.duration)) {
            config.video.duration = getSecondsFromTimeString(config.video.duration);
        }
        this.sponsoredVideoData = config;

        const { player } = this;
        if(player == null){
            this.PlayerReadyCallbacks.push(() => {
                this.loadSponsoredVideo(config);
            })
        }
        else {
            this.sponsoredVideo = new SponsoredVideo(config, this.SVP);
            this.sponsoredVideo.init();
            this.loadPlaylist().then(playlist => {
                var timeIntervals = [25, 50, 75];
                var startStop = [true, true]
                if(window._ismdAngle || window._ismdAffairs || this.playlistVideos.length > 1 || (window._isRecap && $('.has-playlist').length > 0)) {
                    this.recapTemp.createCarousel(this.nextVideoIndex - 1);
                }
                if (!window._ismdAffairs) {
                    this.sticky.setIFIVideo(this.sponsoredVideoData.title, ".content-container.ifi .flex-content");
                }
                player.AmpEventsSources["mediachange"].subscribe(eventData => {
                    if (eventData.videoId == "ifivideo") {
                        this.loadSponsoredContent(config);
                        if (!window._ismdAffairs) {
                            this.sticky.setStickyTitle(config,true);
                            this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                        }
                        if (typeof this.sponsoredVideoData.video["trackingPixel-Start"] == "string" && startStop[0]) {
                            this.loadTrackingPixel(this.sponsoredVideoData.video["trackingPixel-Start"]);
                            startStop[0] = false;
                        }
                        player.AmpEventsSources["timeupdate"].subscribe(_event => {
                            let { currentTime, duration } = player;
                            let timePercent = (currentTime / duration) * 100;
                            if (_event.videoId == "ifivideo") {
                                timeIntervals.forEach((timeInterval, i) => {
                                    if (timePercent > timeInterval) {
                                        timeIntervals.splice(i, 1);
                                        if (this.sponsoredVideoData.video[`trackingPixel-${timeInterval}`]) {
                                            this.loadTrackingPixel(this.sponsoredVideoData.video[`trackingPixel-${timeInterval}`]);
                                        }
                                    }
                                });
                            }
                        });
                        player.AmpEventsSources["ended"].subscribe(___event => {
                            if (___event.videoId == "ifivideo" && this.sponsoredVideoData.video[`trackingPixel-100`] && startStop[1]) {
                                this.loadTrackingPixel(this.sponsoredVideoData.video[`trackingPixel-100`]);
                                startStop[1] = false;
                            }
                            if (___event.videoId == "ifivideo" && this.nextVideoUrl) {
                                this.autoPlayNextVideo();
                            }
                        });
                    } else {
                        this.hideSponsoredContent();
                        if (!window._ismdAffairs) {
                            this.sticky.setIFIVideo(this.sponsoredVideoData.title, ".content-container.ifi .flex-content");
                        }
                    }
                })
                if (player.media.metadata.videoId == "ifiVideo") {
                    this.loadSponsoredContent(config)
                }
                if(playlist.playlistItems.length !== 2){
                    $('.save-tooltip.playlist').hide();
                }
            })
        }

    }
    loadVideo() {

        const { s_sact, s_sactid, s_sptr, s_sprodid, s_sprod } = window;
        let brandParts = s_sptr != null ? s_sptr.split(" ") : [];
        let tracking = {
            moduleName: "vidrecap"
        }

        let videoEl = document.querySelector(this.parentSel + '[data-module="streaming-video-player"]');
        if(!videoEl) return Promise.reject('');
        let videoLoader = new VideoLoader(videoEl, tracking);
        let promise = new Promise((resolve, reject) => {
            videoLoader.load()
                .then((configData) => {

                        let { videoSettings, controlsSettings, apiData } = configData;
                        this.videoApiData = apiData;
                        videoSettings.videoId = "video1";
                        const ccvideoSettings =  this.ccReconfig.reconfiguireCcConfig(apiData, "eed-video");
                        // Added below logic for video chaptering
                        if (ccvideoSettings && ccvideoSettings.chapters) {
                            const chaptersConfigs = ccvideoSettings.chapters;
                            ccvideoSettings.chaptersConfigs = chaptersConfigs;
                            ccvideoSettings.chapters = [];
                        }
                        this.videoSettings = Object.assign({}, ccvideoSettings, videoSettings);
                        videoSettings = this.videoSettings;
                        let self = this;
                        let svpLoader = new SVPLoader();
                        svpLoader.loadSVPLibrary().then(res => {
                            let svp = new Medscape.modules.StreamingVideoPlayer(videoEl,videoSettings,tracking);
                           window.svp = svp;
                            self.SVP = svp;
                            svp.create().then(event => {
                                    self.amp = event.player;
                                    resolve(event);
                                    return event;
                                },
                                error => {
                                    videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
                                    reject(error);
                                })
                        })
                    }, //End  video library Code
                    error => {
                        videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
                        reject(error);
                    })
        });
        return promise;
    }
    insert800Ad(adId, pos) {
                // insert pos 800 and 1800 ads
		adId = 'ads-pos-' + adId;
		let targetElement = Array.from(document.querySelectorAll(this.parentSel + '.page-body > div')).pop();
        if (typeof mscpA2A == 'boolean' && mscpA2A) {
            adId = adId + '-' + currSlctCont.match(/[^/-]+$/)[0];
			targetElement = document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] #layersContainer');
        }
		targetElement.insertAdjacentHTML('beforebegin', '<div id="' + adId + '" class="AdUnit"></div>');
		if (typeof mscpA2A == 'undefined' || !mscpA2A) {
			let defineObj = {
				id: adId,
				pos: pos,
				collapseAfter: true,
				immediate: true,
				internalDefine: false
			}
			webmd.ads2.defineAd(defineObj);
            if(pos === 800) {
                webmd.ads2.refresh({'id':{'ads-pos-800':true}});
            } else {
                webmd.ads2.refresh({'id':{'ads-pos-1800':true}});
            }
		}
        if (!window.performance.getEntriesByName(`eedRecap_${adId}Added`).length) {
            window.performance.mark(`eedRecap_${adId}Added`, {
                detail: "Recap page Ads pos 800/1800 added on the page",
            });
        }
        return this;
    }
    loadTrackingPixel(trackPix) {
        const timestamp = new Date().getTime().toString();
        const trackPixWithTimeStamp = trackPix.replace("[timestamp]", timestamp);
        const trackImg = `<img src=${trackPixWithTimeStamp} height="1" width="1" alt="Advertisement">`;
        if(trackPix) {
            $(".playlist-container").append(trackImg);
        }
    }
    addEventListnerForIFI () {
        window.addEventListener('message', (e) => {
            let message = typeof e.data == "string" && (e.data.indexOf("loadIfiVideo") > 0 || e.data.indexOf("ifiIndiscussion") > 0) ? JSON.parse(e.data) :"";
            if(message.callback && message.callback == "loadIfiVideo") {
                window.Medscape.RecapArticle.loadSponsoredVideo(message['payload']);
            } else if (message.callback && message.callback == "ifiIndiscussion" && !this.indiscussion.isAdServedOrWaitReached) {
                this.performanceMarker('indiscussion');
                this.indiscussion.playPrerollVideo(message['payload']);
            }
        });
    }
    performanceMarker(type) {
        try {
            const eventName = type === 'recap' ? 'eedRecap_800' : 'eedIndiscussion_800';
            const detailMessage = type === 'recap' ? "EED Recap 800/1800 event called" : "EED Indiscussion 800/1800 event called";
            const event = window.performance.mark(eventName, { detail: detailMessage });
            const record = window.performance.measure('ifi event call time', 'eedRecap_start', eventName);
            const performanceEntries = window.performance.getEntriesByType('mark');
            //const marker = performanceEntries.find(entry => entry.name === 'eedRecap_800Added');
            const marker = performanceEntries.find(entry => 
                entry.name === 'eedRecap_ads-pos-1800Added' || entry.name === 'eedRecap_ads-pos-800Added'
            );
            // console.log(`${type} perf markers`,  this.getMeasurementDuration(marker.startTime), this.getMeasurementDuration(event.startTime));
            wmdPageLink(`vid-perf_ifi-${this.getMeasurementDuration(marker.startTime)}|${this.getMeasurementDuration(event.startTime)}`);
        } catch (error) {
            console.log(error);
        }
    }
    gTagConversion() {
        if(window._isRecap && typeof window.gtag == 'function') {
            let gTagConversionParameters = {
                'send_to': 'AW-974275109/EsybCKeBuJYBEKWEydAD'
            };
            window.gtag('event', 'conversion', gTagConversionParameters);
        }
    }
    checkProductName() {
        if ($("#bodypadding").hasClass('care-cues')) { // Care-cues product
            window._isCareCues = true;
            return;
        }
        const pagetype = window.PageMetadata ? window.PageMetadata.pageSegVars.ctype : "";
        switch (pagetype) {
            case 10516: {
                window._ismdAngle = true;
                break;
            }
            case 10517: {
                window._ismdAffairs = true;
                break;
            }
            case 20170: {
                window._isClinicalTrialsCentral = true;
                break;
            }
            default: {
                break;
            }
        }
    }

    // temp code to fix s_sactid on recap [PPE-333551]
    addSactId() {
        if (typeof promoActivity !== 'undefined') {
            window.s_sactid = promoActivity.id;
        }
    }
    indiscussionArticle() {
        if (!isFPFEligible) {
            this.addReadMoreButton();
        }
        this.addToolbarAboveVideo();
        this.addReadTranscripts();
    }
    // Add read more related indiscussion articles
    addReadMoreButton () {
        $('#article-content').children().wrapAll('<div class="indiscussion-article" />')
        $('#article-content').append(`<a class='read-more' ><span class='read-more-gradient'></span></a>`);
        $('div#article-content .read-more').on('click', function(e) {
            if( $(this).prev('div.indiscussion-article').hasClass('expanded')) {
                $(this).prev('div.indiscussion-article').removeClass('expanded');
                $(this).removeClass('expanded');
                wmdPageLink('ind-read_less',this)
                document.getElementById("article-content").scrollIntoView();
            } else {
                $(this).prev('div.indiscussion-article').addClass('expanded');
                $(this).addClass('expanded');
                wmdPageLink('ind-read_more',this)
            }
        });

    }
    addReadMoreCareCues () {
        $('#article-content').children().wrapAll('<div class="care-cues-article" />')
        $('#article-content').append(`<a class='read-more' ><span class='read-more-gradient'></span></a>`);
        $('#article-content .care-cues-article .content-grey-box').insertAfter($('#article-content .read-more'));

        $('div#article-content .read-more').on('click', function(e) {
            if( $(this).prev('div.care-cues-article').hasClass('expanded')) {
                $(this).prev('div.care-cues-article').removeClass('expanded');
                $(this).removeClass('expanded');
                wmdPageLink('trns_close',this)
                document.getElementById("article-content").scrollIntoView();
            } else {
                $(this).prev('div.care-cues-article').addClass('expanded');
                $(this).addClass('expanded');
                wmdPageLink('trns_open',this)
            }
        });
    }
    autoPlayNextVideo () {
        if (this.nextVideoUrl) window.location.href = this.nextVideoUrl;
    }

    addReadTranscripts() {
        let readTranscript = `<div class="medscape-transcript-widget">
            <a id="indiscussion-transcript"><span class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 4.5V18.1667H6.80627C8.45205 18.1667 10.0637 18.6291 11.4581 19.5H11.5V5.65079C9.83494 4.89291 8.02565 4.5 6.19381 4.5H1.5ZM12.5 5.65079V19.5H12.5419C13.9363 18.6291 15.548 18.1667 17.1937 18.1667H22.5V4.5H17.8062C15.9744 4.5 14.1651 4.89291 12.5 5.65079ZM12 4.78001C10.1814 3.9372 8.20015 3.5 6.19381 3.5H1.1758C0.802567 3.5 0.5 3.80257 0.5 4.1758V18.5292C0.5 18.8813 0.785402 19.1667 1.13746 19.1667H6.80627C8.30511 19.1667 9.77206 19.5995 11.0308 20.4133C11.1184 20.4699 11.2204 20.5 11.3247 20.5H12.6753C12.7796 20.5 12.8816 20.4699 12.9692 20.4133C14.2279 19.5995 15.6949 19.1667 17.1937 19.1667H22.8625C23.2146 19.1667 23.5 18.8813 23.5 18.5292V4.1758C23.5 3.80257 23.1974 3.5 22.8242 3.5H17.8062C15.7999 3.5 13.8186 3.9372 12 4.78001Z" fill="#064aa7"/>
            </svg>
            </span>
            <span class="label-container">
            <span class="label-text">Read Transcript</span>
            </span></a></div>`
        $('.indiscussion-toolbar').append(readTranscript);
        $('#indiscussion-transcript').on('click', function(e) {
            wmdPageLink('ind-read_transcript',this);
            document.getElementById("article-content").scrollIntoView();
        })
    }

    addToolbarAboveVideo() {
        $('#eed-video').before('<div class="toolbar js-toolbar indiscussion-toolbar"> </div>');
    }

    patchCmeVideoPlayer(){
        let videoEl = document.getElementById('cme-video-player')
        if(!videoEl) return;
        let videoConfigLoader = new VideoLoader(videoEl);
        videoConfigLoader.load()
        .then((configData) => {
                let { videoSettings, apiData } = configData;
                this.videoApiData = apiData;
                videoSettings.videoId = "video1";
                this.videoSettings = videoSettings;
            })
        .then(()=>{
            const bucketId = $("#bucketCollectionId").length > 0 ? $("#bucketCollectionId").val().split(',')[0] : (typeof window.bucketCollectionId == "string" || typeof window.bucketCollectionId == "number") ? window.bucketCollectionId : "";
            if (bucketId !="") {
                let playListApi = new PlayListAPI();
                playListApi.callApi(bucketId).then((data) => {
                    if (data["articles"]) {
                        this.playlistVideos = [];
                        this.playlistVideos = playListApi.createPlaylist(data["articles"]);
                        this.nextVideoIndex = playListApi.getNextVideoIndex();
                        this.nextVideoUrl = this.nextVideoIndex > 0 && (this.playlistVideos[this.nextVideoIndex] && this.playlistVideos[this.nextVideoIndex]["link"]) ? this.playlistVideos[this.nextVideoIndex]["link"] : "";
                        this.nextVideoTitle = this.nextVideoIndex > 0 && this.playlistVideos[this.nextVideoIndex] ? this.playlistVideos[this.nextVideoIndex]["playlist"]["title"] : "";
                        this.loadPlaylist().then(el => {
                            if (this.playlistVideos.length > 1) {
                                this.recapTemp.createCarousel(this.nextVideoIndex - 1);
                            }

                            // Code to add "now playing" to thumbnails of virtual-symposiyum templates filmstrip/carousel
                            $(".virtual-symposium .playlist-container .recap-playlist-module .recap-playlist-item").each(function(){
                                    let hrefVal = $(this).find("a.video-item").attr('href');
                                    if(hrefVal === "javascript:void(0)" || hrefVal === "javascript:void(0);") {
                                        let divEl = $(this).find(".content-container .flex-content");
                                        if(!divEl.hasClass("now-playing")) {
                                            divEl.addClass("now-playing");
                                        }
                                    }
                            });

                                },
                        error => {
                            console.error("patchCmeVideoPlayer error:", error);
                        });
                    }
                });
            }
        });
    }

    addEventListenerForPRMLinks() {
        let PRMcontainer = `.article-column-${window.breakpoint === 1 ? 'left' : 'right'} .grey-box-care-cues .care-cues-related-links .care-cues-related-links-content`;
        if(window._ismdAngle || $('.md-angle').length > 0) {
            PRMcontainer = `.article-column-${window.breakpoint === 1 ? 'left' : 'right'} .viewarticle-prm-grey-box .viewarticle-prm-grey-box-related-links .viewarticle-prm-grey-box-related-links-content`;
        }
        if ($(PRMcontainer).length > 0) {
            let prmContainers = [...document.querySelectorAll(PRMcontainer)];
            prmContainers.forEach((ele, i) => {
                let links = $(ele).children('a');
                let linksArray = $.makeArray(links);
                $(linksArray).on('click', function (e) {
                    let targetLinkInd = linksArray.indexOf(this);
                    if (targetLinkInd !== -1) {
                        let isPartnerLink = $(this).closest('.care-cues-related-links-content.partner-links').length > 0;
                        wmdPageLink(`ar-prm${isPartnerLink ? '-partner' : ''}_${targetLinkInd + 1}`, this);
                    }
                })
            })
        }
    }

    svgParser(svgString) {
        const parser = new window.DOMParser();
        const svgEl = parser.parseFromString(svgString, 'image/svg+xml');
        return svgEl.documentElement || svgEl;
    }

    generateMuteButtonHTML(){
        const svgString = `
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2739 2.24768C20.9416 4.00855 21.9629 6.38363 21.9629 8.9994C21.9629 11.6152 20.9416 13.9903 19.2739 15.7511C18.8942 16.1521 18.9114 16.7851 19.3124 17.1648C19.7134 17.5446 20.3463 17.5274 20.7261 17.1264C22.7314 15.0089 23.9629 12.1469 23.9629 8.9994C23.9629 5.85194 22.7315 2.98994 20.7261 0.87244C20.3463 0.471443 19.7134 0.454228 19.3124 0.833991C18.9114 1.21375 18.8942 1.84668 19.2739 2.24768ZM7.08579 2.00008C8.34572 0.740143 10.5 1.63249 10.5 3.41429V14.5859C10.5 16.3677 8.34572 17.26 7.08579 16.0001L4.08579 13.0001H2C0.89543 13.0001 0 12.1046 0 11.0001V7.00008C0 5.89551 0.895431 5.00008 2 5.00008L4.08579 5.00008L7.08579 2.00008ZM18.1789 8.9994C18.1789 7.22094 17.4593 5.61248 16.2929 4.44609C15.9024 4.05557 15.9024 3.4224 16.2929 3.03188C16.6834 2.64135 17.3166 2.64135 17.7071 3.03188C19.2332 4.55801 20.1789 6.66921 20.1789 8.9994C20.1789 11.3296 19.2332 13.4408 17.7071 14.9669C17.3166 15.3574 16.6834 15.3574 16.2929 14.9669C15.9024 14.5764 15.9024 13.9432 16.2929 13.5527C17.4593 12.3863 18.1789 10.7779 18.1789 8.9994ZM13.2929 6.83717C13.8473 7.39163 14.1885 8.15471 14.1885 8.99938C14.1885 9.84406 13.8473 10.6071 13.2929 11.1616C12.9024 11.5521 12.9024 12.1853 13.2929 12.5758C13.6834 12.9663 14.3166 12.9663 14.7071 12.5758C15.6213 11.6616 16.1885 10.3958 16.1885 8.99938C16.1885 7.60298 15.6213 6.33715 14.7071 5.42296C14.3166 5.03244 13.6834 5.03244 13.2929 5.42296C12.9024 5.81349 12.9024 6.44665 13.2929 6.83717Z" fill="white"/>
        </svg>
        `;
        const svgEl = this.svgParser(svgString);
        const button = document.createElement('button');
        const label = document.createElement("span");
        const iconContainer = document.createElement("span");
        label.classList.add('label');
        label.innerHTML = 'Tap For Sound';
        iconContainer.classList.add("icon-container");
        iconContainer.appendChild(svgEl);
        button.appendChild(iconContainer);
        button.appendChild(label);
        return button;
    }

    killEvents(player, events){
        events.forEach(event => {
            player.removeEventListener(event);
        })
    }

    patchCmeVideoPlayerForMuteButton(){
        let playerContainerEL = document.getElementById('cme-video-player')
        if(!playerContainerEL) return;
        const player = window.mediaApi || {};
        const events = ['mutechange', 'ended', 'playing'];
        const buttonEL = this.generateMuteButtonHTML();
        const el = document.createElement('div');
        el.classList.add('tap-for-sound-plugin');
        el.classList.add('amp-layer');
        el.appendChild(buttonEL);
        playerContainerEL.querySelector('.cme-player-presenter').appendChild(el);
        const handleClick = (e) => {
            console.log("[TapForSound] handleClick:", e)
            player.unmute();
            // player.enterFullScreen();
        }

        el.addEventListener('click', handleClick)
        buttonEL.addEventListener('click', handleClick)

        player.addEventListener('mutechange', () => {
            // assumes player is unmuted and volume is anything but 0
            if (player.getVolume() !== 0) {
                this.killEvents(player, events);
                el.removeEventListener('click', handleClick);
                buttonEL.removeEventListener('click', handleClick);
                if (el.remove) {
                    el.remove();
                } else {
                    // IE doesn't support remove
                    el.parentNode.removeChild(el);
                }
            }
        })

        player.addEventListener('ended',()=>{
            if(el) el.classList.add("hidden");
        })

        player.addEventListener('playing',()=>{
            if(el) el.classList.remove("hidden");
        })
    }

    waitAndPatchCMEPlayer(){
        let timer = window.setInterval(()=>{
            if(window.mediaApi){
                this.patchCmeVideoPlayerForMuteButton();
                clearInterval(timer);
            }
        },300)
    }

    checkDirectIfi () {
        const __url = new URL(window.location.href);
        const _c = __url.searchParams.get("ifi");
        if([20172, 650146, 590146, 49139, 330148].includes(PageMetadata.pageSegVars.ctype)) {
            return false;
        }
        if (typeof _c !== 'undefined' && _c !== null) {
            return true;
        }
        return false;
    }

    getChaptersfromConfig() {
        let slideInfo = Array.isArray(this.videoApiData.slideInfo) ? this.videoApiData.slideInfo : [];
        let chapterItems = slideInfo.map((item) => {
            return { chapterName: item.chapterTitle, startTime: item.startTime ? item.startTime : '', endTime: item.endTime ? item.endTime : '' };
        }).filter((item) => {
            // validation check for invalid data
            return (item.chapterTitle || item.startTime || item.endTime);
        });
        try {
            const { chaptersConfigs } = this.videoSettings;
            let chapters = typeof chaptersConfigs === 'string' && chaptersConfigs !== '' ? JSON.parse(chaptersConfigs) : chaptersConfigs;
            if (chapters && chapterItems.length > 0) chapters.items = [...chapterItems];
            return chapters;
        }
        catch (err) {
            console.log('Failed to parse Video chapters JSON:', err);
            if (chapterItems.length > 0) return { enable: true, items: [...chapterItems] };
            else return undefined;
        }
    }
    addWatchListButton(callback) {
        try {
            const fabButtonLoad = new WatchListFabButton(callback);
            fabButtonLoad.init();
            this.ApplyBottomToWatchListButton();
        } catch(err){
            console.log('Error Fetching SaveItems:', err);
        }
    }
    addVideoSaverToolBar(){
        const { videoApiData } = this;
        let thumbnail = videoApiData.config.poster;
        if (typeof thumbnail == "undefined" || thumbnail.trim() == "") {
          thumbnail = videoApiData.config.bumperImage;
        }
        let epConfig = {
          isIfi: false,
          isPlaylist: false,
          playlist: {
            thumbnail,
            title: $("h1.title").text(),
          },
          link: location.pathname,
        };
        const videoSaver = new VideoSaver(epConfig);
        videoSaver.init();
        videoSaver.addToToolBar();
    }

    ApplyBottomToWatchListButton() {
        try {
            const footer = document.querySelector('.adhesive-footer-wrapper .AdUnit');
            const button = document.getElementById('fab-button-watchlist');
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const bottomHieght = document.querySelector('.adhesive-footer-wrapper').offsetHeight + 20;
                        button.style.bottom = bottomHieght + 'px';
                    }
                });
            });
            observer.observe(footer);
        } 
        catch (err) {
          console.log(err);
        }
    }
    getMeasurementDuration(measure) {
        if (measure) {
            return (measure / 1000).toFixed(2);
        }
        return null;
    }
}
if (typeof mscpA2A == 'undefined' || !mscpA2A) {
    let recapArticle = new RecapArticle(document.getElementById('bodypadding'));
    recapArticle.init();
}
window.recapArticleInit = function(el) {
	let recapArticle = new RecapArticle(el);
    recapArticle.init();
}
